import { Navigate, useLocation } from 'react-router-dom';

interface LegacyGitSettingsRedirectProps {
  /** Panel to open on `/settings/git`. */
  platform: 'github-app' | 'gitlab' | 'gitea';
  /** Extra params to set, e.g. `{ section: 'byoc' }` for the old GitLab configuration route. */
  extra?: Record<string, string>;
}

/**
 * Redirects the retired per-provider settings routes onto `/settings/git?platform=…`.
 *
 * Merges rather than replaces the incoming query string, which is load-bearing: these paths are
 * still the OAuth `returnTo` targets, so they arrive carrying `status`, `provider`, `gitlabSync`,
 * `connectionId` and friends, and onboarding sends `/settings/gitea?returnTo=…`. A plain
 * `<Navigate to="/settings/git?platform=gitea">` would drop all of it and silently break the
 * post-connect toast and repository sync.
 */
export function LegacyGitSettingsRedirect({ platform, extra }: LegacyGitSettingsRedirectProps) {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  params.set('platform', platform);
  for (const [key, value] of Object.entries(extra ?? {})) {
    params.set(key, value);
  }
  return <Navigate to={`/settings/git?${params.toString()}`} replace />;
}
